import { Behavior, AttachmentRule } from './types';

export class RotationBehavior extends Behavior {
  private rotationSpeed: number = 90; // degrees per second
  private currentRotation: number = 0;

  static getAttachmentRules(): AttachmentRule[] {
    return [
      { type: 'class', selector: 'rotation' },
      { type: 'class', selector: 'rotate' }
    ];
  }

  onAttach(): void {
    console.log('RotationBehavior attached to:', this.element);
  }

  onDetach(): void {
    console.log('RotationBehavior detached from:', this.element);
  }

  test(): void {
    console.log('RotationBehavior test:', this.element);
  }

  tick(deltaTime: number): void {
    this.currentRotation += this.rotationSpeed * deltaTime;
    this.element.setAttribute('ry', this.currentRotation.toString());
  }
} 